import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-solar-subsidy',
  templateUrl: './solar-subsidy.component.html',
  styleUrls: ['./solar-subsidy.component.scss']
})
export class SolarSubsidyComponent {

   constructor(private titleService: Title) { }
   
     ngOnInit() {
        this.titleService.setTitle('Solar Subsidy');
     }

  scrollToCalculator(): void {
    const element = document.getElementById('solar-calculator');

    if (element) {
        element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }
}
}
